var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5316 5.03081L6.53157 13.0308C6.4619 13.1007 6.3791 13.1562 6.28794 13.1941C6.19677 13.2319 6.09904 13.2514 6.00032 13.2514C5.90161 13.2514 5.80387 13.2319 5.71271 13.1941C5.62155 13.1562 5.53875 13.1007 5.46907 13.0308L1.96907 9.53081C1.89931 9.46105 1.84397 9.37823 1.80621 9.28707C1.76846 9.19592 1.74902 9.09823 1.74902 8.99956C1.74902 8.9009 1.76846 8.8032 1.80621 8.71205C1.84397 8.6209 1.89931 8.53808 1.96907 8.46831C2.03884 8.39855 2.12166 8.34321 2.21281 8.30545C2.30397 8.26769 2.40166 8.24826 2.50032 8.24826C2.59899 8.24826 2.69668 8.26769 2.78784 8.30545C2.87899 8.34321 2.96181 8.39855 3.03157 8.46831L6.00095 11.4377L13.4703 3.96956C13.6112 3.82867 13.8023 3.74951 14.0016 3.74951C14.2008 3.74951 14.3919 3.82867 14.5328 3.96956C14.6737 4.11046 14.7529 4.30156 14.7529 4.50081C14.7529 4.70007 14.6737 4.89117 14.5328 5.03206L14.5316 5.03081Z",
    fill: "#98FF7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/greenCheckIcon.90b91e5f7cf8ec86150be44732d2e1d4.svg";
export { ForwardRef as ReactComponent };